var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStickyHeaderStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7903 1.33215C14.482 1.35174 14.4005 3.05568 14.1824 3.28043C13.8627 3.61648 12.5315 3.45779 12.5535 4.17048C12.5662 4.57773 13.8081 4.92609 13.9231 5.31324C14.038 5.70039 13.2746 6.92458 13.7278 7.21209C14.181 7.49961 15.1309 6.04439 15.3543 5.9573C15.6894 5.82668 16.9796 6.75633 17.1787 6.39121C17.4806 5.83912 16.2149 4.83339 16.2074 4.4474C16.2 4.0614 17.2983 3.0607 17.1286 2.64243C16.959 2.22416 15.8702 2.98896 15.5926 2.80723C15.315 2.6255 15.2489 1.28682 14.7903 1.33215Z",
    fill: "#B250FF",
    stroke: "#B250FF",
    strokeWidth: 1.06673,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81256 16.6102C2.26133 16.6102 2.62512 16.2498 2.62512 15.8051C2.62512 15.3605 2.26133 15 1.81256 15C1.36379 15 1 15.3605 1 15.8051C1 16.2498 1.36379 16.6102 1.81256 16.6102Z",
    fill: "#B250FF",
    stroke: "#B250FF",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5718 2.13313C2.88759 2.13313 3.14361 1.87947 3.14361 1.56657C3.14361 1.25366 2.88759 1 2.5718 1C2.256 1 2 1.25366 2 1.56657C2 1.87947 2.256 2.13313 2.5718 2.13313Z",
    fill: "#B250FF",
    stroke: "#B250FF",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyHeaderStar);
export default __webpack_public_path__ + "static/media/sticky_header_star.916c021dd074b14bab63795edd5e6ca1.svg";
export { ForwardRef as ReactComponent };